import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";
import routes from "../routes";

const Navbar = () => {
	const { token, user, logout } = useAuth();
	const [isBurgerActive, setIsBurgerActive] = useState(false);

	useEffect(() => {
		if (!token) logout();
	}, [token, user]);

	const handleLogout = () => {
		logout();
		window.location.href = "/";
	};

	const toggleBurgerMenu = () => {
		setIsBurgerActive(!isBurgerActive);
	};

	return (
		<nav className="navbar" role="navigation" aria-label="main navigation">
			<div className="navbar-brand">
				<Link to="/" className="navbar-item">
					Home
				</Link>

				{/* Burger menu button */}
				<span
					role="button"
					className={`navbar-burger ${isBurgerActive ? "is-active" : ""}`}
					aria-label="menu"
					aria-expanded="false"
					onClick={toggleBurgerMenu}
				>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</span>
			</div>

			{/* Menu items */}
			<div id="navbarBasicExample" className={`navbar-menu ${isBurgerActive ? "is-active" : ""}`}>
				<div className="navbar-end">
					{user && user.username ? (
						<div className="navbar-item">
							<Link className="navbar-item" to={routes.seller}>
								Venditori
							</Link>
							<Link className="navbar-item" to={routes.tag}>
								Tag
							</Link>
							<Link className="navbar-item" to={routes.search}>
								Cerca
							</Link>
							<div className="navbar-item has-dropdown is-hoverable">
								{/* <span className="navbar-link">profilo</span> */}
								<span className="navbar-link">{user.username}</span>
								<div className="navbar-dropdown">
									<Link className="navbar-item" to={routes.profile}>
										Profilo
									</Link>
									<span className="navbar-item is-clickable" onClick={handleLogout}>
										Logout
									</span>
								</div>
							</div>
						</div>
					) : (
						<div className="navbar-end">
							<div className="navbar-item">
								<div className="buttons">
									<Link to={routes.login} className="button is-light">
										Accedi
									</Link>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</nav>
	);
};

export default Navbar;
